import { useMutation } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export interface IDeleteDiscountParameters {
    id: string;
}

export const useDeleteDiscount = (queryKey: string | string[]) => {
    const auth = useAuth();
    return useMutation({
        mutationFn: async (parameters: IDeleteDiscountParameters) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot delete discount without authorization token.",
                );
            }

            return await api.discounts.deleteDiscount({
                ...parameters,
                token: auth.token,
            });
        },
    });
};
